import ApiClient from "../helpers/ApiClient";

const basePerfilEndpoint = `/Perfil`;
const baseUsuarioEndpoint = `/usuarios`;

const getPerfil = () =>
  ApiClient.backendClient.get(`${basePerfilEndpoint}/getPerfil`);

const atualizaPerfil = (data) =>
  ApiClient.backendClient.post(`${basePerfilEndpoint}/atualizaPerfil`, data);

const getUsuarios = () =>
  ApiClient.backendClient.get(`${baseUsuarioEndpoint}/getUsuarios`);

const atualizaStatusUsuario = (data) =>
  ApiClient.backendClient.post(`${baseUsuarioEndpoint}/alterStatus`, data);

const novoUsuario = (data) =>
  ApiClient.backendClient.post(`${baseUsuarioEndpoint}/novo`, data);

const getUsuario = (uid) =>
  ApiClient.backendClient.get(`${baseUsuarioEndpoint}/getUsuario/${uid}`);

const updateUsuario = (data) =>
  ApiClient.backendClient.post(`${baseUsuarioEndpoint}/atualizaUsuario`, data);

const UsuarioApiClient = {
  getPerfil,
  atualizaPerfil,
  getUsuarios,
  atualizaStatusUsuario,
  novoUsuario,
  getUsuario,
  updateUsuario,
};
export default UsuarioApiClient;
